import { useEffect, useState } from 'react';
import nodeAPI from '../../../service/ApiServiceNode';

export default function useOnboardingProgress(clientIds = [], projectIds = []) {
    const query = JSON.stringify({
        clientIds: [...new Set(clientIds.map(Number).filter(id => Number.isSafeInteger(id) && id > 0))].sort((a, b) => a - b),
        projectIds: [...new Set(projectIds.map(Number).filter(id => Number.isSafeInteger(id) && id > 0))].sort((a, b) => a - b),
    });
    const [result, setResult] = useState({ query: '', clients: {}, projects: {} });
    useEffect(() => {
        let cancelled = false;
        const ids = JSON.parse(query);
        const all = [
            ...ids.clientIds.map(id => ({ type: 'clientIds', id })),
            ...ids.projectIds.map(id => ({ type: 'projectIds', id })),
        ];
        if (!all.length) return undefined;
        async function load() {
            try {
                const clients = {};
                const projects = {};
                for (let start = 0; start < all.length; start += 200) {
                    const batch = all.slice(start, start + 200);
                    const response = await nodeAPI.get('/project/onboarding-progress', { params: {
                        clientIds: batch.filter(item => item.type === 'clientIds').map(item => item.id).join(','),
                        projectIds: batch.filter(item => item.type === 'projectIds').map(item => item.id).join(','),
                    } });
                    if (cancelled) return;
                    const data = response.data.data;
                    (data.clients || []).forEach(item => { clients[item.hrpClientId] = item; });
                    (data.projects || []).forEach(item => { projects[item.hrpProjectId] = item; });
                }
                if (!cancelled) setResult({ query, clients, projects });
            } catch {
                if (!cancelled) setResult({ query, clients: {}, projects: {} });
            }
        }
        load();
        return () => { cancelled = true; };
    }, [query]);
    return result.query === query ? result : { clients: {}, projects: {} };
}
